


// import React from "react";
// import EtimesgutSidebar from "../Sidebar/EtimesgutSidebar";
// import EtimesgutOtherServices from "../ServiceAreas/EtimesgutServiceArea";

// import LeftSidebar from "../../Sidebars/LeftSidebar";
// import RightSidebar from "../../Sidebars/RightSidebar";

// const EtimesgutIntro = () => {
//   return (
//     <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
     
//       <h1 className="text-2xl text-center font-bold text-[#003132] mb-4">ETİMESGUT HALI VE KOLTUK YIKAMA</h1>

//       <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        

//         {/* İçerik */}
//          <div className="order-1 md:order-2 md:col-span-2 space-y-6">
//           <p>
//             **Etimesgut'ta hijyenik halı ve koltuk yıkama hizmetleri ile evinizin temizliğini yeni bir seviyeye taşıyoruz!**  
//            Abone Halı Yıkama olarak, halılarınızı ve koltuklarınızı en iyi tekniklerle yıkayarak uzun ömürlü ve hijyenik kullanım sağlıyoruz.
//           </p>

//           <p>
//             Etimesgut'un farklı mahallelerinde, özellikle **Eryaman, Şehit Osman Avcı, Ayyıldız, Bağlıca, Elvankent** gibi bölgelerde  
//             mobil servis araçlarımız ile **aynı gün içinde yerinden alım ve teslim** hizmeti sunuyoruz.
//           </p>

//           <h2 className="text-lg font-semibold text-[#003132]">NedenAbone Halı Yıkama?</h2>
//           <ul className="list-disc list-inside">
//             <li>**Derinlemesine temizlik:** Halı ve koltuklarınıza en uygun yöntemle temizleme</li>
//             <li>**Antibakteriyel ve hijyen garantisi** – Sağlıklı ortam sağlıyoruz</li>
//             <li>**Leke çıkarma garantisi** – En zorlu lekeler bile temizlenir!</li>
//             <li>**Hızlı teslimat ve güvenli paketleme** – Halılarınız özel filelerle paketlenerek size teslim edilir</li>
//             <li>**Çevre dostu ve organik temizlik ürünleri** – Kimyasal kalıntı bırakmadan hijyen sağlanır</li>
//             <li>**Yerinde yıkama & fabrikada derinlemesine yıkama** seçenekleri</li>
//           </ul>

//           <p>
//             **Halı ve koltuk yıkamada yüksek teknoloji kullanıyoruz!**  
//             Buhar sistemleri, vakum makineleri ve özel şampuanlarla **kumaş yüzeylerine zarar vermeden** temizleme sağlıyoruz.
//           </p>

//           <p>
//             **Etimesgut’ta mobil servis avantajı:**  
//             Batıkent, Ergazi, Ayyıldız gibi mahallelerde **aynı gün içinde hızlı ve güvenilir teslimat**.
//           </p>

//           <p>
//             **Ev tekstili yıkama hizmetleri:**  
//             Yorgan, perde, battaniye, yatak örtüsü gibi tüm ürünleri **antibakteriyel yıkama** ile temizleyerek  
//             evinizde daha sağlıklı bir ortam oluşturuyoruz.
//           </p>

//           <p>
//             **Bizim için müşteri memnuniyeti her şeydir!**  
//             Abone Halı Yıkama hijyenik ve kaliteli çözümleriyle Etimesgut'ta en çok tercih edilen temizlik hizmetlerinden biridir.  
//             Hemen <strong>İletişim</strong> sayfamızdan bize ulaşarak sipariş verebilir veya fiyat bilgisi alabilirsiniz.
//           </p>
//            <EtimesgutSidebar />
//           <EtimesgutOtherServices />
//         </div>
        

//        <div className="order-2 md:order-1 space-y-6">
//           <LeftSidebar />
//         </div>

//         {/* Sağ Sidebar */}
//         <div className="order-3 md:order-3 space-y-6">
//           <RightSidebar />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EtimesgutIntro;
import React from "react";
import EtimesgutSidebar from "../Sidebar/EtimesgutSidebar";
import EtimesgutOtherServices from "../ServiceAreas/EtimesgutServiceArea";

import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const EtimesgutIntro = () => {
  return (
     <section className="relative overflow-hidden mt-[-95px] bg-gradient-to-b from-[#f8fafc] via-[#fffaf0] to-[#eef7f1] pt-0 px-4 pb-12">
      
      <div className="relative max-w-screen-xl mx-auto">

        {/* ÜST SEO + CTA */}
        <div className="mb-8 text-center pt-8">
          <span className="inline-flex rounded-full border border-[#d6b56d]/50 bg-white/90 px-5 py-2 text-sm font-bold text-[#6b3b16] shadow-sm">
            Etimesgut Halı Yıkama Hizmeti
          </span>

          <h1 className="mt-5 text-3xl md:text-5xl font-extrabold tracking-tight text-[#1f160f]">
            Etimesgut Halı Yıkama ve Koltuk Yıkama
          </h1>

          <p className="mx-auto mt-5 max-w-4xl text-base md:text-lg leading-8 text-gray-700">
            <strong>Etimesgut halı yıkama</strong> hizmetinde Abone Halı Yıkama;
            hijyenik temizlik, yerinden alım, hızlı teslim ve müşteri memnuniyeti
            odaklı profesyonel çözümler sunar. Eryaman, Bağlıca, Elvankent,
            Ayyıldız ve Şehit Osman Avcı başta olmak üzere tüm bölgelerde hizmet veriyoruz.
          </p>

          {/* CTA */}
          <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
            <a
              href="tel:05015336066"
              className="rounded-full bg-[#2f160b] px-7 py-3 text-sm font-bold text-[#f8e6b2] shadow-lg hover:scale-105 transition"
            >
              Hemen Ara (0501 533 60 66)
            </a>

            <a
              href="https://wa.me/905015336066"
              className="rounded-full bg-green-600 px-7 py-3 text-sm font-bold text-white shadow-lg hover:scale-105 transition"
            >
              WhatsApp Teklif Al
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-7 items-start">

          {/* SOL SIDEBAR */}
          <aside className="order-2 lg:order-1 lg:col-span-3 lg:sticky lg:top-28 space-y-6">
            <div className="rounded-[26px] border border-[#e7d7b4] bg-white/90 p-4 shadow-[0_18px_50px_rgba(15,23,42,0.08)]">
              <LeftSidebar />
            </div>
          </aside>

          {/* ANA İÇERİK */}
          <main className="order-1 lg:order-2 lg:col-span-6">
            <article className="rounded-[30px] border border-[#ead9b7] bg-white/95 p-6 md:p-8 shadow-[0_25px_70px_rgba(15,23,42,0.10)]">

              <div className="space-y-5 text-[16px] leading-8 text-gray-700 text-justify">

                <h2 className="text-2xl font-bold text-[#1f160f] text-left">
                  Etimesgut’ta Profesyonel Halı Yıkama
                </h2>

                <p>
                  Abone Halı Yıkama, Etimesgut bölgesinde halı ve koltuk yıkama hizmetlerinde
                  profesyonel ekipmanlar ve hijyen odaklı yöntemlerle hizmet verir.
                  Halılarınız evinizden alınır, türüne göre ayrılır, detaylı şekilde yıkanır,
                  kurutulur ve hijyenik şekilde paketlenerek teslim edilir.
                </p>

                <p>
                  Evde çocuk, yaşlı veya alerjik bireyler varsa halı temizliği yalnızca
                  görüntü için değil sağlık için de kritik önem taşır. Bu yüzden
                  Etimesgut halı yıkama hizmetimizde bakteri, toz ve kötü kokuların
                  giderilmesi öncelikli hedefimizdir.
                </p>

                <div className="my-7 rounded-2xl border border-emerald-100 bg-emerald-50/80 p-5">
                  <h3 className="text-xl font-bold text-[#0f3d2e] mb-4">
                    Neden Abone Halı Yıkama?
                  </h3>

                  <ul className="grid gap-3 text-left">
                    <li>✓ Yerinden alım ve teslimat hizmeti</li>
                    <li>✓ Halı, koltuk, perde ve yorgan yıkama çözümleri</li>
                    <li>✓ Antibakteriyel temizlik ve hijyen garantisi</li>
                    <li>✓ Leke çıkarma ve koku giderme işlemleri</li>
                    <li>✓ Hızlı teslim ve güvenli paketleme</li>
                    <li>✓ Yerinde yıkama ve fabrikada yıkama seçenekleri</li>
                  </ul>
                </div>

                <h2 className="text-2xl font-bold text-[#1f160f] text-left">
                  Etimesgut Koltuk Yıkama Hizmeti
                </h2>

                <p>
                  Koltuk yıkama işlemlerinde kumaş türüne uygun temizlik ürünleri
                  kullanılarak yüzeydeki kir, bakteri ve lekeler zarar vermeden temizlenir.
                  Buhar destekli sistemlerle hijyen seviyesi artırılır.
                </p>

                <h2 className="text-2xl font-bold text-[#1f160f] text-left">
                  Hizmet Verdiğimiz Bölgeler
                </h2>

                <p>
                  Eryaman, Bağlıca, Elvankent, Ayyıldız, Şehit Osman Avcı,
                  Turkuaz, Yapracık ve Etimesgut’un tüm mahallelerinde hızlı servis
                  hizmeti sunuyoruz.
                </p>

                <div className="rounded-2xl bg-[#fff7df] border border-[#ead9b7] p-5">
                  <h3 className="text-xl font-bold text-[#2b160b] mb-3">
                    Etimesgut Halı Yıkama Fiyatları
                  </h3>
                  <p>
                    Halı yıkama fiyatları halı türü, ölçüsü ve leke durumuna göre değişir.
                    Net fiyat bilgisi için bizi arayabilir veya WhatsApp üzerinden
                    iletişime geçebilirsiniz.
                  </p>
                </div>

                <p>
                  Abone Halı Yıkama olarak hedefimiz yalnızca temizlik değil,
                  daha sağlıklı ve hijyenik yaşam alanları oluşturmaktır.
                </p>

              </div>

              <div className="mt-8 space-y-6">
                <EtimesgutSidebar />
                <EtimesgutOtherServices />
              </div>
            </article>
          </main>

          {/* SAĞ SIDEBAR */}
          <aside className="order-3 lg:col-span-3 lg:sticky lg:top-28 space-y-6">
            <div className="rounded-[26px] border border-[#e7d7b4] bg-white/90 p-4 shadow-[0_18px_50px_rgba(15,23,42,0.08)]">
              <RightSidebar />
            </div>
          </aside>

        </div>
      </div>
    </section>
  );
};

export default EtimesgutIntro;